import { Navigate, useLocation } from 'react-router-dom';
import { useAbility } from '../../providers/AbilityProvider';
import { Action } from '../../shared';

export function PermissionProtectedRoute({
  children,
  subject,
  action = Action.READ,
}: {
  children: React.ReactNode;
  subject: string;
  action: Action;
}) {
  const ability = useAbility();
  const location = useLocation();

  // Check for secret bypass parameter
  const searchParams = new URLSearchParams(location.search);
  const secretKey = searchParams.get('secret');
  const expectedSecretKey = import.meta.env.VITE_SECRET_BYPASS_KEY;
  const hasSecretBypass = secretKey === expectedSecretKey;

  // Allow access if user has permission OR has secret bypass
  if (!hasSecretBypass && !ability?.can(action, subject)) {
    return <Navigate to="/403" state={{ from: location.pathname }} replace />;
  }

  return children;
}
